import {Injectable} from "@angular/core";
import {HttpService} from "../_service/http.service";

@Injectable()
export class PhoneService {

  constructor(private httpService: HttpService) {
  }

  static isPhoneNumberCorrect(phoneNumber) {
    if (phoneNumber === '') {
      return false;
    }
    // const phoneRegex = new RegExp(/^((\(\d{3}\))|(\d{3}))?([ \-])?(\d{3}[\- ]?\d{2}[\- ]?\d{2})$/);
    const phoneRegex = new RegExp(/^\d{10}$/);
    return phoneRegex.test(phoneNumber);
  }

  async sendConfirmationCode(phoneNumber: string, isPhoneNeedToBeUnique: boolean = true): Promise<string> {
    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/sendConfirmationCode');
    sb.push('?');
    sb.push('&phoneNumber=');
    sb.push(encodeURIComponent(phoneNumber));
    sb.push('&isPhoneExist=');
    sb.push(!isPhoneNeedToBeUnique);

    let response = null;

    await this.httpService.postData(sb.join(''), null)
      .then((data) => {
        response = data;
        console.log("Received data in sendConfirmationCode is: ", data);
      }, (error) => {
        console.log("Received error in sendConfirmationCode is: ", error);
        throw error;
      });
    return response;
  }

  async resendConfirmationCode(phoneNumber: string): Promise<string> {
    console.log("In resend conf code ", phoneNumber);
    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/resendConfirmationCode?');
    sb.push('&phoneNumber=');
    sb.push(encodeURIComponent(phoneNumber));
    let response = null;

    await this.httpService.postData(sb.join(''), null)
      .then((data) => {
        console.log("Received data in resendConfirmationCode is: ", data);
        response = data;
      }, (error) => {
        console.log("Received error in resendConfirmationCode is: ", error);
        throw error;
      });

    return response;
  }

  async checkConfirmationCode(code: string, phoneNumber: string): Promise<string> {
    console.log("In check conf code ", code);
    const sb = [];
    sb.push('rest/checkConfirmationCode?');
    sb.push('&code=');
    sb.push(code);
    sb.push('&phoneNumber=');
    sb.push(encodeURIComponent(phoneNumber));

    let response = null;
    await this.httpService.postData(sb.join(''), null)
      .then((data) => {
        console.log("Received data in checkConfirmationCode is: ", data);
        response = data;
      }, (error) => {
        console.log("Received error in checkConfirmationCode is: ", error);
        throw error;
      });

    return response;
  }

}

// @Directive({
//   selector: '[formControlName][phone]',
//   host: {
//     '(ngModelChange)': 'onInputChange($event)',
//     '(keydown.backspace)': 'onInputChange($event.target.value)'
//   }
// })
// export class PhoneMaskDirective {
//   constructor(public model: NgControl) {
//   }
//
//   @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();
//
//   onInputChange(e) {
//
//     const x = e.replace(/\D/g, '').match(/(\d{0,10})/);
//     e = '+7' + x[1];
//
//     // set the new value
//     this.model.valueAccessor.writeValue(e);
//     this.rawChange.emit(e);
//   }
// }



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/phone/phone.service.ts